import React, { Component } from 'react';
import AppSidebar from "../components/AppSidebar";
import PageHeader from "../components/PageHeader";
import PanelGroupController from "../components/PanelGroupController";
import PromoCodesList from "./views/PromoCodesList";
import PromoCodePropertiesPanel from "./panels/PromoCodePropertiesPanel";
import ActionButton from "../components/ActionButton";
import {fromJS, List, Map} from "immutable";
import SearchQueriesPanel from "../components/panels/SearchQueriesPanel";
import FilterPanel from '../components/panels/FilterPanel';
import PanelHeaderItem from '../components/PanelHeaderItem';
import { requestCreatePromoCode, requestEditPromoCode } from "../actions/SalesApiActions";
import {connect} from 'react-redux';


// Filter options used in the right hand panel
const promoCodesFilterOptions = fromJS([
  {id: "", label: "All"},
  {id: "active", label: "Active"},
  {id: "expire_within_month", label: "Will expire within one month"},
  {id: "expired", label: "Expired"},
  {id: "disabled", label: "Disabled"},
]);

const searchOptions = fromJS([
  {prop: "code", label: "Code", type: "string"},
  {prop: "description", label: "Description", type: "string"},
])

class PromoCodesPage extends Component {

  constructor(props) {
    super(props);
    this.handleSetSelection = this.handleSetSelection.bind(this);
    this.state = {
      code: "",
      hasSelection: false,
      selectedPanelId: "general",
      promoCodesFilter: "active",
    }
  }

  render() {
    const page = this.props.route.page || "codes";
    let view = this.renderView(page);
    let panels = this.renderPanels(page);

    let title = "Promo Codes";

    return (
      <div className="PromoCodesPage">;
        <AppSidebar />
        <PageHeader title={title} />
        <div className="PageContainer">
          {view}
        </div>
        <div className="PanelContainer">
          <div className="header">
            <PanelHeaderItem label="Filter" id="general" selectedId={this.state.selectedPanelId} onClick={this.handlePanelItemSelection.bind(this)} />
            <PanelHeaderItem label="Search" id="search" selectedId={this.state.selectedPanelId} onClick={this.handlePanelItemSelection.bind(this)} />
          </div>
          {panels}
          <PanelGroupController title="Actions">
            <ActionButton
              label="View Orders"
              active={this.state.hasSelection}
              onClick={this.handleViewOrders.bind(this)} />
            <ActionButton
              label="Edit Promo Code"
              active={this.state.hasSelection}
              onClick={this.handleEditPromoCode.bind(this)} />
            <ActionButton
              label="Create Promo Code"
              onClick={this.handleCreatePromoCode.bind(this)} />
          </PanelGroupController>
        </div>
      </div>
    )
  }

  renderView(page) {
    let searchQueries = Map(this.props.router.location.query);

    return (
      <PromoCodesList
        selectedId={this.state.code}
        onSelectionChange={this.handleSetSelection}
        promoCodesFilter={this.state.promoCodesFilter}
        filters={searchQueries.toJS()}
        />
    )
  }


  renderPanels(page) {
    return this.state.selectedPanelId === "general"
      ? this.buildPanels(List(["promoCodesFilter", PromoCodePropertiesPanel]))
      : this.buildPanels(List([SearchQueriesPanel]));
  }

  buildPanels(panels) {
    return panels.map(x => this.buildPanel(x));
  }

  buildPanel(component) {
    switch(component) {
      case PromoCodePropertiesPanel:
        return <PromoCodePropertiesPanel
                key="PromoCodePropertiesPanel"
                expanded={true}
                code={this.state.code}
                hasSelection={this.state.hasSelection}
                />
      case "promoCodesFilter":
        return <FilterPanel
          key="promoCodesFilterPanel"
          title="Promo Codes Filter"
          expanded={true}
          options={promoCodesFilterOptions}
          onClick={this.handleSetPromoCodesFilter.bind(this)}
          filter={this.state.promoCodesFilter}
          />
      case SearchQueriesPanel:
        return <SearchQueriesPanel
                key="SearchQueriesPanel"
                expanded={true}
                properties={searchOptions}
                query={Map(this.props.router.location.query)}
                onChange={this.handleSearchParamChange.bind(this)}
                onClear={this.handleSearchClear.bind(this)}
                />
      default:
        return null;      
    }
  }

  handlePanelItemSelection(id) {
    this.setState({selectedPanelId: id});
  }

  handleSearchParamChange(prop, value) {
    let searchQueries = Map(this.props.router.location.query)
    if (value === "") {
      searchQueries = searchQueries.delete(prop)
    } else {
      searchQueries = searchQueries.set(prop, value);
    }
    this.props.router.push({
      pathname: "/sales/promo-codes",
      query: searchQueries.toJS()
    });
  }

  handleSearchClear() {
    let searchQueries = Map(this.props.router.location.query);
    let searchOptionKeys = searchOptions.map((val) => val.get("prop"));
    let emptySearchQueries = searchOptionKeys.reduce((acc, key) => {
      return acc.delete(key);
    }, searchQueries);

    this.props.router.push({
      pathname: "/sales/promo-codes",
      query: emptySearchQueries.toJS()
    });
  }

  handleSetSelection(id) {
    this.setState({code: id, hasSelection: true});
  }

  handleSetPromoCodesFilter(item) {
    this.setState({
      promoCodesFilter: item.get("id")
    });
  }

  handleViewOrders() {
    this.props.router.push({pathname: "/sales/orders", query: {promoCode: this.state.code}});
  }

  handleEditPromoCode() {
    this.props.requestEditPromoCode(this.state.code);
  }

  handleCreatePromoCode() {
    this.props.requestCreatePromoCode();
  }
}

export default connect(null, {requestCreatePromoCode, requestEditPromoCode})(PromoCodesPage);
